/**
 * Fixes for the 3 JS errors flagged in Microsoft Clarity on this project
 * (10 total errors logged, so treat this as directional, not certain).
 * Vanilla JS, no dependencies. Add as /assets/clarity-js-error-fixes.js
 * and load it FIRST in theme.liquid, right after <head>:
 *
 *   {{ 'clarity-js-error-fixes.js' | asset_url | script_tag }}
 */

(function () {
  "use strict";

  /* ------------------------------------------------------------------
   * 1. "ResizeObserver loop completed with undelivered notifications" — 80%
   *    Harmless browser warning, not a real bug. A ResizeObserver
   *    callback is changing size synchronously (sliders/carousels,
   *    sticky headers, lazy-load libs). Defer callbacks a frame and
   *    silence the message so it stops polluting error tracking.
   * ------------------------------------------------------------------ */
  if (typeof window.ResizeObserver !== "undefined") {
    var NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = function (callback) {
      return new NativeResizeObserver(function (entries, observer) {
        window.requestAnimationFrame(function () {
          callback(entries, observer);
        });
      });
    };
    window.ResizeObserver.prototype = NativeResizeObserver.prototype;
  }

  window.addEventListener(
    "error",
    function (e) {
      if (e.message && e.message.indexOf("ResizeObserver loop") !== -1) {
        e.stopImmediatePropagation();
      }
    },
    true
  );

  /* ------------------------------------------------------------------
   * 2. "Cannot read properties of null (reading 'body')" — 10%
   *    Almost always a script that runs before <body> exists yet —
   *    e.g. it's placed in <head> without `defer`, and does something
   *    like document.body.classList.add(...), document.body.appendChild(...),
   *    or new MutationObserver(...).observe(document.body, ...) while
   *    document.body is still null. Also happens with
   *    iframe.contentDocument.body or DOMParser results when the
   *    document/iframe hasn't loaded yet.
   *
   *    Real fix: find the offending inline/external script in the theme
   *    (check theme.liquid, header sections, and any app embed blocks
   *    injected in <head>) and either add `defer` to the <script> tag or
   *    wrap its body-touching code like this:
   * ------------------------------------------------------------------ */
  window.onBodyReady = function (callback) {
    if (document.body) {
      callback();
    } else {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    }
  };
  // Usage in the offending script:
  //   onBodyReady(function () { document.body.classList.add('foo'); });

  /* ------------------------------------------------------------------
   * 3. "undefined is not an object (evaluating 'window.webkit.messagehandlers')" — 10%
   *    window.webkit is undefined; a third-party script (pixel, chat
   *    widget, review app) assumes it's running inside an iOS WKWebView
   *    and calls window.webkit.messageHandlers.x.postMessage() without
   *    checking first. Stub it so those calls no-op instead of throwing.
   *    Must load before pixels/apps to work.
   * ------------------------------------------------------------------ */
  if (typeof window.webkit === "undefined") {
    var noopHandler = { postMessage: function () {} };
    window.webkit = {
      messageHandlers: new Proxy(
        {},
        {
          get: function () {
            return noopHandler;
          },
        }
      ),
    };
  }
})();